import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import BackButton from '../components/BackButton';
import { Sparkles, Calculator, FileText, BarChart, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Nouveautes = () => {
  const nouveautes = [
    {
      titre: "Estimateur solidaire BATICO en ligne",
      description: "Estimez vos contributions solidaires RCD en temps réel avec notre nouvel outil intelligent",
      icon: Calculator,
      date: "Mars 2025",
      badge: "Disponible",
      link: "/calculateur-batico"
    },
    {
      titre: "Procès-Verbaux numériques",
      description: "Soumettez vos PV de chantier directement en ligne avec suivi en temps réel",
      icon: FileText,
      date: "Février 2025",
      badge: "Disponible",
      link: "/login"
    },
    {
      titre: "Tableau de bord statistiques",
      description: "Visualisez vos performances et statistiques avec des graphiques interactifs",
      icon: BarChart,
      date: "Janvier 2025",
      badge: "Disponible",
      link: "/login"
    },
    {
      titre: "Application mobile",
      description: "Accédez à votre espace membre depuis votre smartphone ou tablette",
      icon: Sparkles,
      date: "À venir",
      badge: "Bientôt",
      link: null
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <Navigation />      {/* Bouton Retour */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4">
        <BackButton to="/" label="Retour à l'accueil" />
      </div>

      <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <Sparkles className="h-16 w-16 mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Nouveautés</h1>
            <p className="text-xl text-purple-100 max-w-3xl mx-auto">
              Découvrez les dernières innovations de notre plateforme coopérative
            </p>
          </div>
        </div>
      </div>

      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {nouveautes.map((item, index) => {
              const Icon = item.icon;
              const isAvailable = item.badge === "Disponible";
              
              return (
                <Card key={index} className="hover:shadow-xl transition-all">
                  <CardHeader>
                    <div className="flex items-start justify-between mb-4">
                      <div className="bg-purple-100 p-3 rounded-lg">
                        <Icon className="h-8 w-8 text-purple-600" />
                      </div>
                      <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                        isAvailable 
                          ? 'bg-green-700 text-white' 
                          : 'bg-amber-600 text-white'
                      }`}>
                        {item.badge}
                      </span>
                    </div>
                    <CardTitle className="text-2xl">{item.titre}</CardTitle>
                    <CardDescription className="text-base mt-2">{item.description}</CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-500">{item.date}</span>
                      {item.link ? (
                        <Link to={item.link}>
                          <Button className="bg-purple-600 hover:bg-purple-700">
                            Découvrir
                            <ArrowRight className="h-4 w-4 ml-2" />
                          </Button>
                        </Link>
                      ) : (
                        <Button disabled variant="outline">
                          Bientôt disponible
                        </Button>
                      )}
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <Card className="mt-12 bg-gradient-to-r from-purple-50 to-indigo-50 border-2 border-purple-200">
            <CardContent className="p-8 text-center">
              <Sparkles className="h-12 w-12 mx-auto text-purple-600 mb-4" />
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Restons connectés</h2>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
                Suivez nos actualités pour être informé des prochaines fonctionnalités
              </p>
              <Link to="/actualites">
                <Button size="lg" className="bg-purple-600 hover:bg-purple-700">
                  Voir les actualités
                </Button>
              </Link>
            </CardContent>
          </Card>

            </div>
      </div>

      <Footer />
    </div>
  );
};

export default Nouveautes;